import { render, staticRenderFns } from "./DetailsTextAreaInput.vue?vue&type=template&id=51af371f"
import script from "./DetailsTextAreaInput.vue?vue&type=script&lang=ts"
export * from "./DetailsTextAreaInput.vue?vue&type=script&lang=ts"
import style0 from "./DetailsTextAreaInput.vue?vue&type=style&index=0&id=51af371f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports